import React from 'react'

const DoctorDaycare = () => {
  return (
    <div className='mx-auto p-4'>
      DoctorDaycare
    </div>
  )
}

export default DoctorDaycare
